import { render, staticRenderFns } from "./DiaryRecord.vue?vue&type=template&id=587024fe&scoped=true&"
import script from "./DiaryRecord.vue?vue&type=script&lang=js&"
export * from "./DiaryRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587024fe",
  null
  
)

export default component.exports